<div (click)="window.innerWidth <= mobileMaxWidth ? openWeekSelectorModal() : menuTrigger.openMenu()">
  <div #contentSlot>
    <ng-content></ng-content>
  </div>

  @if (!contentSlot.children.length) {
    <lla-selector-card
      [label]="singleSelection ? 'Select Week' : 'Select Weeks'"
      [value]="selectedWeeksLabel"
      [extraClasses]="extraClasses"
    ></lla-selector-card>
  }
</div>

<div
  [matMenuTriggerFor]="dateRangePickerMenu"
  #menuTrigger="matMenuTrigger"
  (menuOpened)="menuIsOpen = true"
  (menuClosed)="menuIsOpen = false"
></div>

<mat-menu
  #dateRangePickerMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="lla-filter-menu-full"
>
  <div
    class="flex-1 flex flex-col overflow-auto w-full md:w-[600px] bg-contrast border border-ui-separator"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (menuIsOpen) {
      <lla-week-selector
        [singleSelection]="singleSelection"
        [includeFuture]="includeFuture"
        [selectedWeeks]="selectedWeeksValue"
        (selectedWeeksChanged)="onSelectedWeeksChanged($event); menuTrigger.closeMenu()"
        (canceld)="menuTrigger.closeMenu()"
      ></lla-week-selector>
    }
  </div>
</mat-menu>
